import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green,red } from '@material-ui/core/colors';
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import CheckIcon from '@material-ui/icons/Check';
import SaveIcon from '@material-ui/icons/Save';
import Failed from '@material-ui/icons/SmsFailedRounded';
import { Dialog, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    margin: theme.spacing(2),
    position: 'relative',
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonFailure: {
    backgroundColor: red[500],
    '&:hover': {
      backgroundColor:red[700]
    }
  },
  fabProgress: {
    color: green[500],
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

export default function ResponseModal({responseOpen,setResponseOpen, loading, success}) {
  const classes = useStyles();
 
 

  const buttonClassname = clsx({
    [classes.buttonSuccess]: success===true,
    [classes.buttonFailure]:success===false
  });

 

  return  (
      <Dialog open={responseOpen}>
    <div className={classes.root}>
      <div className={classes.wrapper}>
        <Fab
          aria-label="save"
          color="primary"
          className={buttonClassname}
          
        >

          {success ? <CheckIcon onClick={()=>setResponseOpen(false)}  /> : <Failed/>}
        </Fab>
        {loading && <CircularProgress size={68} className={classes.fabProgress} />}
      </div>
      <div className={classes.wrapper}>
       
          {success ? <Typography>Kindly Check Your Mail.</Typography>:<Typography style={{color:"red"}}>The email provided is not valid!!! </Typography>}
        
        </div>
        <Button style={{marginRight:"5px", color:"white",backgroundColor:"#3f51b5"}} size='small' onClick={()=>setResponseOpen(false)}>Close</Button>
    </div>

    </Dialog>
  )
  
}